import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import pruefPlanStores from "../../../Stores/PruefPlanStore";
import pruef_PlanConstants from "../../../Constants/Pruef_PlanConstants";
import { toast } from "react-toastify";
import Pruef_PlanActions from "../../../Actions/Pruef_PlanActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";

const CreateTemplate = (props) => {
  const {
    isCreateTemplateModalOpen,
    checklistDataForTemplate,
    saveAsTemplateCallback,
  } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  var displaystyle = isCreateTemplateModalOpen
    ? { display: "block" }
    : { display: "none" };
  var _class = isCreateTemplateModalOpen ? "show" : "";
  //var _inputForm = inputForm.isOpen ? inputForm.result : null;
  const [templateName, setTemplateName] = useState("");

  const saveTemplate = (e) => {
    e.preventDefault();
    let tempChecklistDate = { ...checklistDataForTemplate };
    if (tempChecklistDate) {
      delete tempChecklistDate["referenceID"];
      tempChecklistDate.title = templateName;
    }
    setGlobalSpinner(true);
    Pruef_PlanActions.SaveChecklistAsTemplate(tempChecklistDate);
  };

  useEffect(() => {
    function saveCheckListAsTemplateSuccess() {
      const res = pruefPlanStores.getSaveChecklistAsTemplateResult();
      if (res) {
        toast.success(localization.templateSaveSuccess);
        setTemplateName("");
        saveAsTemplateCallback("SUCCESS");
      }
      setGlobalSpinner(false);
    }
    function saveCheckListAsTemplateFailure() {
      const res = pruefPlanStores.getSaveChecklistAsTemplateResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_SUCCESS,
      saveCheckListAsTemplateSuccess
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_FAILURE,
      saveCheckListAsTemplateFailure
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_SUCCESS,
        saveCheckListAsTemplateSuccess
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_FAILURE,
        saveCheckListAsTemplateFailure
      );
    };
  }, []);

  return isCreateTemplateModalOpen ? (
    <div>
      {" "}
      <div className="overlay"></div>
      <div
        className={"modal in " + _class}
        id="CreateTemplatePopUp"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="CreateTemplatePopUpTitle"
        data-focus="false"
        aria-hidden="true"
        style={({ opacity: "1", width: "700px" }, displaystyle)}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="MsgModalLongTitle">
                {localization.saveAsTemplate}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="CreateTemplatePopUpClose"
                onClick={() => {
                  setTemplateName("");
                  saveAsTemplateCallback("CLOSE");
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form id="herstellerAdd" autoComplete="off" onSubmit={saveTemplate}>
              <div className="modal-body confrimation-modal-body">
                <div className="form-outline mb-4">
                  <label className="form-label" htmlFor="templateTitle">
                    {localization.nameOfTemplate}
                  </label>
                  <input
                    type="text"
                    id="templateTitle"
                    name="templateTitle"
                    className="form-control"
                    required
                    placeholder={localization.enterNameOfTemplate}
                    value={templateName}
                    onChange={(e) => {
                      setTemplateName(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer p-3">
                <button type="submit" className="btn btn-primary">
                  {localization.save}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
export default CreateTemplate;
